import dayjs from 'dayjs'
import { IFnOCategoryStock } from './types/options-chain'
import Text from '@/stories/components/Common/NewText'
import TransposedDataTable from '@/stories/components/DetailPage/TransposedDataTable'

type TProps = {
  categoryData?: IFnOCategoryStock[]
  heading?: string
}

const FnOListingWidgetV1 = ({ categoryData, heading }: TProps) => {
  if (!categoryData?.length) {
    return null
  }
  return (
    <div>
      {heading && (
        <div className="flex items-center justify-between">
          <Text appearance="heading3">{heading}</Text>
        </div>
      )}
      <TransposedDataTable
        details={{
          contents: [
            {
              tables: [
                {
                  table: {
                    columnHeader: [
                      { title: 'Name', id: 1, trait: 'text' },
                      { title: 'Expiry', id: 2, trait: 'text' },
                      { title: 'Strike Price', id: 3, trait: 'text' },
                      { title: 'LTP', id: 4, trait: 'text' },
                      { title: 'Absolute Change', id: 5, trait: 'text' },
                      { title: 'Change', id: 6, trait: 'text' },
                    ],
                    rows: categoryData?.map(el => ({
                      url: el.relativepath,
                      noIndexUrl: true,
                      columns: [
                        {
                          title: el.stock_name ?? '-',
                          headerId: 1,
                        },
                        {
                          title: dayjs(
                            el.segment_meta_data?.expiry_display,
                          ).format('MMMM D, YYYY'),
                          headerId: 2,
                        },
                        {
                          title:
                            Number(el.segment_meta_data?.strike_price) > 0
                              ? `₹${el.segment_meta_data?.strike_price}`
                              : '-',
                          headerId: 3,
                        },
                        { title: `₹${el.live_price}`, headerId: 4 },
                        {
                          title: `${el.absolute_change}`,
                          headerId: 5,
                          textColor:
                            el.absolute_change > 0 ? '#33A34D' : '#DF3C27',
                        },
                        {
                          title: `${el.oneD_change}%`,
                          headerId: 6,
                          textColor:
                            Number(el.oneD_change) > 0 ? '#33A34D' : '#DF3C27',
                        },
                      ],
                    })),
                  },
                },
              ],
            },
          ],
        }}
      />
    </div>
  )
}

export default FnOListingWidgetV1
